<template>
	<div class="body">
		<div class="industry-container">

			<div class="title-ctr">
				<el-button type="primary" icon="el-icon-download" size="small" @click="clickRoute(row)"
					style="opacity: 0;">撰写指导</el-button>

				<div class="content-title" v-if="title">
					<img class="title-wing" src="../assets/icons/title_wing_left.png" />
					<span class="title-text">{{ title }}</span>
					<img class="title-wing" src="../assets/icons/title_wing_right.png" />
				</div>

				<el-button type="primary" icon="el-icon-download" size="small" @click="clickRoute(row)">撰写指导</el-button>
			</div>

			<div class="thesis-cnt-ctr">
				<div class="thesis-search-ctr">
					<el-form :inline="true">
						<el-input v-model="name" placeholder="请输入名字" class="thesis-input" />
						<el-button type="primary" @click="clickConfirm()">确 定</el-button>
					</el-form>
				</div>


				<el-table border :data="dataList">
					<el-table-column label="论文名称" align="center" prop="name" />
					<el-table-column label="作者" align="center" prop="author" />
					<el-table-column label="操作" align="center" prop="college_name">
						<template v-slot="{ row }">
							<el-button type="primary" icon="el-icon-download" size="small"
								@click="clickShowMaterial(row)">查看素材</el-button>
							<el-button type="primary" icon="el-icon-download" size="small"
								@click="clickRoute(row)">下载论文</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
						:limit.sync="queryParams.pageSize" @pagination="requestData" />
				</div>
			</div>

		</div>
		
		<el-dialog title="论文素材" :visible.sync="showMaterialDialog" append-to-body v-if="showMaterialDialog"
			align="center">
		
			<el-form :inline="true" align="left">
				<el-form-item label="省直辖市">
					<el-select class="select-width" v-model="province" placeholder="请选择" :clearable=true
						@change="changeProvince">
						<el-option v-for="item in provinceList" :key="item.province_code"
							:label="item.province_name" :value="item.province_code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		
			<div class="data-table">
				<el-table :data="materialList" border>
					<el-table-column prop="name" label="素材名" align="center"></el-table-column>
					<el-table-column prop="province_name" label="省直辖市" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickRoute(row)">下载</el-button>
						</template>
					</el-table-column>
		
				</el-table>
		
				<div class="pagination">
					<pagination v-show="total>0" :total="materialTotal" :page.sync="materialQueryParams.page"
						:limit.sync="materialQueryParams.pageSize" @pagination="requestMaterialData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseDialog()">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getThesisData,
		getMaterialData
	} from "@/api/service"
	
	import {
		getAddrTree,
	} from "@/api/matrix"

	import {
		isEmpty
	} from "@/utils/util"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	export default {
		name: "Matrix",
		data() {
			return {
				name: '',
				title: '',
				tabIndex: 0,
				dataList: [],
				materialList: [],
				queryParams: {
					page: 1,
					pageSize: 20
				},
				materialQueryParams: {
					page: 1,
					pageSize: 10
				},
				province: '',
				provinceList: [],
				showMaterialDialog: false,
				docId: '',
				total: 0,
				materialTotal: 0
			}
		},
		created() {
			console.log('params', this.$route.query)
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				this.initParams();
				getThesisData(this.queryParams).then(res => {
					this.title = res.data.title;
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},
			
			requestMaterialData(){
				this.initMaterialParams();
				getMaterialData(this.materialQueryParams).then(res => {
					this.materialList = res.data.list;
					this.materialTotal = res.data.pageData.totalCount;
				});
			},

			initParams() {
				this.queryParams['name'] = this.name;
			},
			
			initMaterialParams() {
				this.materialQueryParams['province_code'] = this.province;
			},

			initPassParams() {
				let params = this.$route.query
				console.log('initPassParams params', params)

			},
			
			loadProvince() {
				getAddrTree().then(res => {
					this.provinceList = res.data.tree;
				});
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			clickConfirm(){
				this.requestData();
			},
			
			clickCloseDialog(){
				this.showMaterialDialog = false;
			},
			
			clickShowMaterial(row){
				this.docId = row.id;
				this.materialQueryParams['doc_id'] = this.docId;
				this.showMaterialDialog = true;
				this.materialList = [];
				this.requestMaterialData();
				this.loadProvince();
			},
			
			changeProvince(value) {
				console.log('province: ', value);
				// this.provinceList.forEach(element => {
				// 	if (element.province_code == value) {
				// 		this.cityList = element.list;
				// 	}
				// });
				this.requestMaterialData();
			},
			
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "thesis.scss";
</style>